import { $api } from "../AxiosInstance";

export class NotificationService {
  static async getWebNotifications() {
    return await $api.get("/api/admin/webSiteNotificationTemplate/all");
  }

  static async getWebNotificationById(id) {
    return await $api.get("/api/admin/webSiteNotificationTemplate", {
      params: { id },
    });
  }

  static async saveWebNotification(params) {
    return await $api.post("/api/admin/webSiteNotificationTemplate", params);
  }

  static async viewWebNotification(params) {
    return await $api.post("/api/admin/webSiteNotificationTemplate/view", params);
  }
}
